<login-container titel="Log ind med dit ID og kodeord" [arbejder]="(loginInput?.arbejder ?? false) || loadingIndstillinger">
    @if (dashboardStatus && dashboardStatus.freetext && dashboardStatus.login) {
    <div
        class="dashboard-status"
        [style]="{
                background: dashboardStatus.status === 'error' ? '#f8d7da' : dashboardStatus.status === 'warning' ? '#fff3cd' : '#fff',
                border: dashboardStatus.status === 'error' ? '2px solid #b71c1c' : dashboardStatus.status === 'warning' ? '2px solid #bfa100' : '2px solid #ccc'
            }"
    >
        <p [innerHTML]="dashboardStatus.freetext"></p>
    </div>
    }

    <login-input
        #loginInput
        id="login-input"
        [parent]="form"
        [technicianLogin]="true"
        [technicianContactPhone]="technicianContactPhone"
        [loginDisabled]="loadingIndstillinger"
        emailPlaceholder="ID"
        passwordPlaceholder="Adgangskode"
        [showHelpLink]="false"
        helpLinkText="Har du brug for hjælp til login?"
        forgotPasswordText="Glemt adgangskode?"
        [showFirstTimeLink]="false"
        (loginSucceeded)="onLoginSucceeded()"
    >
        <ng-template #biometricLoginButton>
            @if (isBiometricAvailable) {
            <button mat-raised-button color="secondary" type="button" (click)="biometricLogin()" [disabled]="!isBiometricAvailable">
                {{ biometricEnabled ? biometricActionText : "Aktiver biometrisk login" }}
            </button>
            }
        </ng-template>
    </login-input>
    <div login-footer class="login-contact" style="text-align: center">
        Problemer med login? Så ring hjem!<br />
        {{ technicianContactPhone || "" }}
    </div>
</login-container>
